import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IRtpFundingDetails } from '../../interfaces/lmt/rtp-funding-details.interface';
import { AbstractFundingDetailsService } from '../abstraction/abstract.funding-details.service';

@Injectable({
  providedIn: 'root',
})
export class FundingDetailsService extends AbstractFundingDetailsService {
  controller = `/manager/rtp/fundingdetails`;
  urlFundingDetails = `${environment.apiUrl}${this.controller}/getfundingdetails`;

  constructor(private http: HttpClient) {
    super();
  }

  getRtpFundingDetails(): Promise<IRtpFundingDetails | undefined> {
    return this.http.get<IRtpFundingDetails>(`${this.urlFundingDetails}`).toPromise();
  }
}
